import { memo } from '../../lib/teact/teact';
import { getActions } from '../../global';

import { exitSeatLogin, IS_SEAT_EMBEDDED } from '../../seat/seatBridge';

import Button from '../ui/Button';

/**
 * 席位登录页左上角的返回按钮：回到父页的「请选择登录方式」，
 * 不然用户点进单号登录就没法再回去用批量接码。
 * 返回时把登录流程重置回输入手机号阶段，不保留验证码/二步密码进度
 */
const SeatAuthBack = () => {
  if (!IS_SEAT_EMBEDDED) return undefined;

  const handleClick = () => {
    getActions().returnToAuthPhoneNumber();
    exitSeatLogin();
  };

  return (
    <Button
      size="smaller"
      round
      color="translucent"
      className="auth-close"
      iconName="arrow-left"
      ariaLabel="返回"
      onClick={handleClick}
    />
  );
};

export default memo(SeatAuthBack);
